'use client';

import { useId } from 'react';

type StarProps = { isHalf?: boolean } & React.SVGProps<SVGSVGElement>;
export const Star = ({ isHalf, ...props }: StarProps) => {
  const id = useId();
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      {isHalf ? (
        <defs>
          <linearGradient
            id={`half-star-${id}`}
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop
              offset="50%"
              stopColor="var(--star-color)"
              style={{ stopColor: 'var(--star-color)' }}
            />
            <stop offset="50%" stopColor="#ffffff" />
          </linearGradient>
        </defs>
      ) : null}
      <path
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        fill={isHalf ? `url(#half-star-${id})` : undefined}
      />
    </svg>
  );
};
